/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import { useEffect, useState } from "react";
import { changeTopNavigationElements } from "../slices/navigationPanel/navigationPanelSlice";
import { changeTabMenu } from "../slices/tabPane/tabPaneSlice";
import updateElement, { updateArtifactAssessmentComponentElement, updateArtifactAssessmentContentElement, updateNarrativeElement } from "../functions/updateElement";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import NarrativeEntry, { DisplayFromFHIRXhtml } from "../datatypeComponents/NarrativeEntry";
import ReferenceEntry, { DisplayFromFHIRReference, displayStringFromFHIRReference } from "../datatypeComponents/ReferenceEntry";
import DatatypeSelector from "../datatypeComponents/DatatypeSelector";
import UriEntry, { DisplayFromFHIRUri } from "../datatypeComponents/UriEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import { Button, Table } from "semantic-ui-react";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import CodeableConceptEntry, { displayStringFromFHIRCodeableConcept, getCodeableConceptDisplayForObjectOrArray, simpleDisplayStringFromFHIRCodeableConcept } from "../datatypeComponents/CodeableConceptEntry";
import QuantityEntry, { displayStringFromFHIRQuantity } from "../datatypeComponents/QuantityEntry";
import { DisplayFromFHIRRelatesTo } from "../datatypeComponents/RelatesToEntry";
import BooleanEntry from "../datatypeComponents/BooleanEntry";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import CodeEntry from "../datatypeComponents/CodeEntry";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../slices/viewingOlderVersion/viewingOlderVersionSlice";
import UnsignedIntEntry from "../datatypeComponents/UnsignedIntEntry";

const emptyContent = {
    "id": "",
    "summary": "",
    "type": "",
    "classifier": [],
    "quantity": "",
    "author": [],
    "path": [],
    "relatesTo": [],
    "freeToShare": "",
    "component": []
};

const AdaptationTableDisplay = ({ contentArray }) => {
    if (Array.isArray(contentArray) && contentArray.length > 0) {
        return <div>
            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell style={{ backgroundColor: "#E2DDEF" }}>Element</Table.HeaderCell>
                        <Table.HeaderCell style={{ backgroundColor: "#E2DDEF" }}>Original Content</Table.HeaderCell>
                        <Table.HeaderCell style={{ backgroundColor: "#E2DDEF" }}>Revised Content</Table.HeaderCell>
                        <Table.HeaderCell style={{ backgroundColor: "#E2DDEF" }}>Rationale for Change</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {contentArray?.map((content, contentIndex) => {
                        let contentPath = "";
                        if (content.path.length === 1) {
                            contentPath = content.path[0];
                        }
                        if (content.path.length === 2) {
                            contentPath = content.path[0] + " " + content.path[1];
                        }
                        let summary0 = content?.component?.[0]?.summary || "";
                        let summary1 = content?.component?.[1]?.summary || "";
                        let summary2 = content?.component?.[2]?.summary || "";
                        if (typeof summary0 === "object") {
                            summary0 = JSON.stringify(summary0);
                        }
                        if (typeof summary1 === "object") {
                            summary1 = JSON.stringify(summary1);
                        }
                        let datatype = content?.classifier?.[0]?.text;
                        switch (datatype) {
                            case "CodeableConcept":
                                if (summary0) {
                                    try {
                                        summary0 = displayStringFromFHIRCodeableConcept(JSON.parse(summary0));
                                    } catch {
                                        //
                                    }
                                }
                                if (summary1) {
                                    try {
                                        summary1 = displayStringFromFHIRCodeableConcept(JSON.parse(summary1));
                                    } catch {
                                        //
                                    }
                                }
                                break;
                            case "ArrayOfCodeableConcept":
                                if (summary0) {
                                    try {
                                        summary0 = getCodeableConceptDisplayForObjectOrArray(JSON.parse(summary0));
                                    } catch {
                                        //
                                    }
                                }
                                if (summary1) {
                                    try {
                                        summary1 = getCodeableConceptDisplayForObjectOrArray(JSON.parse(summary1));
                                    } catch {
                                        //
                                    }
                                }
                                break;
                            case "Reference":
                                if (summary0) {
                                    try {
                                        summary0 = displayStringFromFHIRReference(JSON.parse(summary0));
                                    } catch {
                                        //
                                    }
                                }
                                if (summary1) {
                                    try {
                                        summary1 = displayStringFromFHIRReference(JSON.parse(summary1));
                                    } catch {
                                        //
                                    }
                                }
                                break;
                            default:
                            // summary0 and summary1 are already strings
                        }
                        return <Table.Row key={contentIndex}>
                            <Table.Cell>{contentPath}</Table.Cell>
                            <Table.Cell>{summary0}</Table.Cell>
                            <Table.Cell>{summary1}</Table.Cell>
                            <Table.Cell>{summary2}</Table.Cell>
                        </Table.Row>
                    })}
                </Table.Body>
            </Table>
        </div>
    } else {
        return <></>
    }
}

const ArtifactAssessmentComponentDisplay = ({ foi, contentIndex, componentIndex, componentPath }) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    const [componentState, setComponentState] = useState({});

    useEffect(() => {
        if (resourceJson?.content?.[contentIndex] && componentPath.length > 0) {
            if (componentPath.length === 1) {
                if (resourceJson.content[contentIndex].component?.[componentPath[0]]) {
                    setComponentState(resourceJson.content[contentIndex].component[componentPath[0]]);
                } else {
                    setComponentState(emptyContent);
                }
            } else if (componentPath.length === 2) {
                if (resourceJson.content[contentIndex].component[componentPath[0]].component?.[componentPath[1]]) {
                    setComponentState(resourceJson.content[contentIndex].component[componentPath[0]].component[componentPath[1]]);
                } else { setComponentState(emptyContent); }
            } else if (componentPath.length === 3) {
                if (resourceJson.content[contentIndex].component[componentPath[0]].component[componentPath[1]].component?.[componentPath[2]]) {
                    setComponentState(resourceJson.content[contentIndex].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]]);
                } else { setComponentState(emptyContent); }
            } else if (componentPath.length === 4) {
                if (resourceJson.content[contentIndex].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component?.[componentPath[3]]) {
                    setComponentState(resourceJson.content[contentIndex].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]]);
                } else { setComponentState(emptyContent); }
            } else if (componentPath.length === 5) {
                if (resourceJson.content[contentIndex].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component?.[componentPath[4]]) {
                    setComponentState(resourceJson.content[contentIndex].component[componentPath[0]].component[componentPath[1]].component[componentPath[2]].component[componentPath[3]].component[componentPath[4]]);
                } else { setComponentState(emptyContent); }
            } else if (editMode) {
                alert("Content.component levels 6-deep are not supported.");
            }
        }
    }, [resourceJson]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "summary", "markdown", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.summary]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "type", "CodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.type]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "classifier", "ArrayOfCodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.classifier]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "quantity", "Quantity", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.quantity]);

    useEffect(() => {
        if (typeof componentState.author === "string") {
            let newAuthor = [{ "display": componentState.author }];
            setComponentState(prevState => { return { ...prevState, "author": newAuthor }; });
        }
        if (editMode && resourceJson && typeof componentState.author !== "string") {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "author", "ArrayOfReference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.author]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "path", "ArrayOfUri", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.path]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "relatesTo", "ArrayOfRelatesTo", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.relatesTo]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentComponentElement(componentState, contentIndex, componentPath,
                "freeToShare", "boolean", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [componentState.freeToShare]);

    return <div style={{ marginLeft: "24px" }}>
        {editMode ?
            <>
                <CodeableConceptEntry elementName='type' fieldLabel='Type'
                    startingValue={componentState.type}
                    setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.type &&
                    <p><b>Type: </b>{simpleDisplayStringFromFHIRCodeableConcept(componentState.type)}</p>}
            </>
        }
        {editMode ?
            <>
                <MarkdownEntry elementName='summary' fieldLabel='Summary'
                    startingValue={componentState.summary}
                    setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.summary && <DisplayFromFHIRMarkdown markdown={componentState.summary} />}
            </>
        }
        {editMode ?
            <>
                <ArrayEntry datatype='CodeableConcept'
                    elementName='classifier' fieldLabel='Rating or Classifier'
                    startingValue={componentState.classifier} setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.classifier &&
                    <p><b>Rating(s): </b>{getCodeableConceptDisplayForObjectOrArray(componentState.classifier)}</p>}
            </>
        }
        {editMode ?
            <>
                <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                    startingValue={componentState.quantity}
                    setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.quantity &&
                    <p><b>Quantity: </b>{displayStringFromFHIRQuantity(componentState.quantity)}</p>}
            </>
        }
        {editMode ?
            <>
                <ArrayEntry datatype='Reference'
                    elementName='author' fieldLabel='Author (Rater)'
                    referencedResourceTypes={["Patient", "Practitioner", "PractitionerRole", "Organization", "Device"]}
                    startingValue={componentState.author} setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.author?.length > 0 && componentState.author.map((author, authorIndex) => {
                    return <div key={authorIndex}>
                        <span><b>Author: </b><DisplayFromFHIRReference reference={author} /></span>
                    </div>
                })
                }
            </>
        }
        {editMode ?
            <>
                <ArrayEntry datatype='string'
                    elementName='path' fieldLabel='Path (specific to)'
                    startingValue={componentState.path} setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.path?.length > 0 &&
                    <p><b>Specific to: </b>{componentState.path.join(", ")}</p>
                }
            </>
        }
        {editMode ?
            <>
                <ArrayEntry datatype='RelatesTo'
                    elementName='relatesTo' fieldLabel='Related Item'
                    startingValue={componentState.relatesTo} setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.relatesTo?.length > 0 && componentState.relatesTo.map((relatesTo, itemIndex) => {
                    return <div key={itemIndex}>
                        <span><b>Related Item: </b><DisplayFromFHIRRelatesTo relatesTo={relatesTo} /></span>
                    </div>
                })
                }
            </>
        }
        {editMode ?
            <>
                <BooleanEntry elementName='freeToShare' fieldLabel='Free to share?'
                    startingValue={componentState.freeToShare} storeFalse={true}
                    setResourceState={setComponentState} />
            </>
            :
            <>
                {componentState.freeToShare === true && <p>Free to share.</p>}
                {componentState.freeToShare === false && <p>NOT free to share.</p>}
            </>
        }
        {(componentState.component?.length > 0) &&
            componentState.component.map((component, componentIndex) => {
                let newComponentPath = componentPath.concat([componentIndex]);
                return <div key={componentIndex}>
                    <ArtifactAssessmentComponentDisplay foi={foi}
                        contentIndex={contentIndex}
                        componentIndex={componentIndex}
                        componentPath={newComponentPath} />
                    <br />
                </div>
            })}
        {editMode &&
            <Button className="formButton" style={{ color: "#000000" }}
                content="+ Add Component"
                onClick={() => {
                    setComponentState(prevState => {
                        let newComponent = prevState.component?.length > 0 ?
                            prevState.component.concat(emptyContent)
                            :
                            [emptyContent];
                        return { ...prevState, "component": newComponent };
                    });
                }}
            />
        }
    </div>
}

const ArtifactAssessmentContentDisplay = ({ foi, contentIndex, isCertaintyOfEvidenceProfile,
    isClassificationProfile, isCommentProfile, isOutcomeImportanceProfile
}) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    const [contentState, setContentState] = useState({});
    const [outcomeImportanceState, setOutcomeImportanceState] = useState({});

    useEffect(() => {
        if (resourceJson?.content?.[contentIndex]) {
            let contentInstance = JSON.parse(JSON.stringify(resourceJson.content[contentIndex]));
            if (typeof contentInstance.author === "string") {
                contentInstance.author = [{ "display": contentInstance.author }]
            }
            setContentState(contentInstance);
            if (isOutcomeImportanceProfile) {
                let typeCode = contentInstance.type?.coding?.[0]?.code;
                let desirabilityClassifier = "";
                let relativeImportanceQuantity = "";
                let populationReference = "";
                if (typeCode === "outcome-desirability") {
                    desirabilityClassifier = contentInstance.classifier?.[0] || "";
                } else if (typeCode === "relative-importance") {
                    relativeImportanceQuantity = contentInstance.quantity?.value || "";
                } else if (typeCode === "population") {
                    populationReference = contentInstance.relatesTo?.[0]?.targetReference || "";
                }
                setOutcomeImportanceState({
                    "desirabilityClassifier": JSON.parse(JSON.stringify(desirabilityClassifier)),
                    "relativeImportanceQuantity": JSON.parse(JSON.stringify(relativeImportanceQuantity)),
                    "populationReference": JSON.parse(JSON.stringify(populationReference))
                });
            }
        }
    }, [resourceJson]);

    useEffect(() => {
        if (outcomeImportanceState.desirabilityClassifier) {
            setContentState(prevState => {
                return {
                    ...prevState,
                    "classifier": [outcomeImportanceState.desirabilityClassifier]
                };
            });
        }
    }, [outcomeImportanceState.desirabilityClassifier]);

    useEffect(() => {
        if (outcomeImportanceState.relativeImportanceQuantity ||
            outcomeImportanceState.relativeImportanceQuantity === 0
        ) {
            setContentState(prevState => {
                return {
                    ...prevState,
                    "quantity": {
                        "value": outcomeImportanceState.relativeImportanceQuantity,
                        "unit": "%",
                        "system": "http://unitsofmeasure.org",
                        "code": "%"
                    }
                };
            });
        }
    }, [outcomeImportanceState.relativeImportanceQuantity]);

    useEffect(() => {
        if (outcomeImportanceState.populationReference) {
            setContentState(prevState => {
                return {
                    ...prevState,
                    "relatesTo": [{
                        "type": {
                        "coding": [
                            {
                                "system": "http://terminology.hl7.org/CodeSystem/artifact-relationship-type",
                                "code": "supports",
                                "display": "Supports"
                            }
                        ]
                    },
                        "targetReference": outcomeImportanceState.populationReference
                    }]
                };
            });
        }
    }, [outcomeImportanceState.populationReference]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "summary", "markdown", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.summary]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "type", "CodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.type]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "classifier", "ArrayOfCodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.classifier]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "quantity", "Quantity", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.quantity]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "author", "ArrayOfReference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.author]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "path", "ArrayOfUri", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.path]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "relatesTo", "ArrayOfRelatesTo", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.relatesTo]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateArtifactAssessmentContentElement(contentState, contentIndex,
                "freeToShare", "boolean", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [contentState.freeToShare]);

    return <div>
        {isOutcomeImportanceProfile ?
            <h4>
                {contentState?.type?.coding?.[0]?.code === "outcome-desirability" ?
                    "Outcome Desirability"
                    :
                    contentState?.type?.coding?.[0]?.code === "relative-importance" ?
                        "Relative Importance (as %)"
                        :
                        contentState?.type?.coding?.[0]?.code === "population" ?
                            "For Whom"
                            :
                            "Rating " + (contentIndex + 1)
                }
            </h4>
            :
            isClassificationProfile ?
                <h4>Classification {contentIndex + 1}</h4>
                :
                isCommentProfile ?
                    <h4>Comment {contentIndex + 1}</h4>
                    :
                    <h4>Rating {contentIndex + 1}</h4>
        }
        <div style={{ marginLeft: "24px" }}>
            {(editMode && isOutcomeImportanceProfile && (
                contentState?.type?.coding?.[0]?.code === "outcome-desirability" ||
                contentState?.type?.coding?.[0]?.code === "relative-importance" ||
                contentState?.type?.coding?.[0]?.code === "population"
            )) ?
                <>
                    {contentState?.type?.coding?.[0]?.code === "population" &&
                        <MarkdownEntry elementName='summary' fieldLabel='Summary'
                            startingValue={contentState.summary}
                            setResourceState={setContentState} />
                    }
                    {contentState?.type?.coding?.[0]?.code === "outcome-desirability" &&
                        <CodeableConceptEntry elementName='desirabilityClassifier'
                            fieldLabel='Outcome Desirability'
                            codeableConceptLevelValueSet={[
                                {
                                    "coding": [
                                        {
                                            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/desirability-codesystem",
                                            "code": "desirable", "display": "Desirable"
                                        }
                                    ]
                                },
                                {
                                    "coding": [
                                        {
                                            "system": "http://hl7.org/fhir/uv/ebm/CodeSystem/desirability-codesystem",
                                            "code": "undesirable", "display": "Undesirable"
                                        }
                                    ]
                                }
                            ]}
                            startingValue={outcomeImportanceState.desirabilityClassifier}
                            setResourceState={setOutcomeImportanceState} />
                    }
                    {contentState?.type?.coding?.[0]?.code === "relative-importance" &&
                        <UnsignedIntEntry elementName='relativeImportanceQuantity'
                            fieldLabel='Relative Importance (%)'
                            startingValue={outcomeImportanceState.relativeImportanceQuantity}
                            setResourceState={setOutcomeImportanceState} />
                    }
                    {contentState?.type?.coding?.[0]?.code === "population" &&
                        <ReferenceEntry elementName='populationReference'
                            fieldLabel='For Whom'
                            referencedResourceTypes={["Group", "Patient", "Practitioner",
                                "PractitionerRole", "RelatedPerson", "CareTeam", "Device",
                                "HealthcareService", "Organization"]}
                            enableCreation={true}
                            startingValue={outcomeImportanceState.populationReference}
                            setResourceState={setOutcomeImportanceState} />
                    }
                </>
                :
                <>
                    {editMode ?
                        <>
                            <CodeableConceptEntry elementName='type' fieldLabel='Type'
                                startingValue={contentState.type}
                                setResourceState={setContentState} />
                        </>
                        :
                        <>
                            {contentState.type &&
                                <p><b>Type: </b>{simpleDisplayStringFromFHIRCodeableConcept(contentState.type)}</p>}
                        </>
                    }
                    {editMode ?
                        <>
                            <MarkdownEntry elementName='summary' fieldLabel='Summary'
                                startingValue={contentState.summary}
                                setResourceState={setContentState} />
                        </>
                        :
                        <>
                            {contentState.summary && <DisplayFromFHIRMarkdown markdown={contentState.summary} />}
                        </>
                    }
                    {editMode ?
                        <>
                            <ArrayEntry datatype='CodeableConcept'
                                elementName='classifier'
                                fieldLabel='Rating or Classifier'
                                startingValue={contentState.classifier}
                                setResourceState={setContentState} />
                        </>
                        :
                        <>
                            {contentState.classifier &&
                                <p><b>Rating(s): </b>{getCodeableConceptDisplayForObjectOrArray(contentState.classifier)}</p>}
                        </>
                    }
                    {editMode ?
                        <>
                            <QuantityEntry elementName='quantity' fieldLabel='Quantity'
                                startingValue={contentState.quantity}
                                setResourceState={setContentState} />
                        </>
                        :
                        <>
                            {contentState.quantity &&
                                <p><b>Quantity: </b>{displayStringFromFHIRQuantity(contentState.quantity)}</p>}
                        </>
                    }
                    {editMode ?
                        <>
                            <ArrayEntry datatype='Reference'
                                elementName='author' fieldLabel='Author (Rater)'
                                referencedResourceTypes={["Patient", "Practitioner", "PractitionerRole", "Organization", "Device"]}
                                startingValue={contentState.author} setResourceState={setContentState} />
                        </>
                        :
                        <>
                            {(Array.isArray(contentState.author) && contentState.author?.length > 0) &&
                                contentState.author.map((author, authorIndex) => {
                                    return <div key={authorIndex}>
                                        <span><b>Author: </b><DisplayFromFHIRReference reference={author} /></span>
                                    </div>
                                })
                            }
                        </>
                    }
                    {editMode ?
                        <>
                            <ArrayEntry datatype='string'
                                elementName='path' fieldLabel='Path (specific to)'
                                startingValue={contentState.path} setResourceState={setContentState} />
                        </>
                        :
                        <>
                            {contentState.path?.length > 0 &&
                                <p><b>Specific to: </b>{contentState.path.join(", ")}</p>
                            }
                        </>
                    }
                    {editMode ?
                        <>
                            <ArrayEntry datatype='RelatesTo'
                                elementName='relatesTo' fieldLabel='Related Item'
                                startingValue={contentState.relatesTo} setResourceState={setContentState} />
                        </>
                        :
                        <>
                            {contentState.relatesTo?.length > 0 && contentState.relatesTo.map((relatesTo, itemIndex) => {
                                return <div key={itemIndex}>
                                    <span><b>Related Item: </b><DisplayFromFHIRRelatesTo relatesTo={relatesTo} /></span>
                                </div>
                            })
                            }
                        </>
                    }
                </>
            }
            {editMode ?
                <>
                    <BooleanEntry elementName='freeToShare' fieldLabel='Free to share?'
                        startingValue={contentState.freeToShare} storeFalse={true}
                        setResourceState={setContentState} />
                </>
                :
                <>
                    {contentState.freeToShare === true && <p>Free to share.</p>}
                    {contentState.freeToShare === false && <p>NOT free to share.</p>}
                </>
            }
            {(contentState.component?.length > 0) &&
                contentState.component.map((component, componentIndex) => {
                    return <div key={componentIndex}>
                        <ArtifactAssessmentComponentDisplay foi={foi}
                            contentIndex={contentIndex}
                            componentIndex={componentIndex}
                            componentPath={[componentIndex]} />
                        <br />
                    </div>
                })}
            {editMode &&
                <Button className="formButton" style={{ color: "#000000" }}
                    content="+ Add Component"
                    onClick={() => {
                        setContentState(prevState => {
                            let newComponent = prevState.component?.length > 0 ?
                                prevState.component.concat(emptyContent)
                                :
                                [emptyContent];
                            return { ...prevState, "component": newComponent };
                        });
                    }}
                />
            }
        </div>
    </div>
}

const ArtifactAssessmentDisplay = ({ foi }) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const displayTitle = parentResourceDetail?.displayTitle;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));
    let isCommentProfile;
    let isClassificationProfile;
    let isRatingProfile;
    let isDateAsRatingProfile;
    let isEvidenceAssessmentProfile;
    let isCertaintyOfEvidenceProfile;
    let isRiskOfBiasProfile;
    let isRecommendationRatingProfile;
    let isRecommendationJustificationProfile;
    let isOutcomeImportanceProfile;
    let isCompositeRatingProfile;
    let isAdaptationProfile;
    let isComparisonProfile;
    let itemRatedHeader = "he Resource Being Rated";

    if (resourceJson.meta?.profile?.length) {
        for (const profile of resourceJson.meta.profile) {
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comment") {
                isCommentProfile = true;
                itemRatedHeader = "he Resource Being Commented On";
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/classification") {
                isClassificationProfile = true;
                itemRatedHeader = "he Resource Being Classified";
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/rating") {
                isRatingProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/date-as-rating") {
                isClassificationProfile = true;
                isDateAsRatingProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-assessment") {
                isEvidenceAssessmentProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/certainty-of-evidence") {
                isEvidenceAssessmentProfile = true;
                isCertaintyOfEvidenceProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/risk-of-bias") {
                isEvidenceAssessmentProfile = true;
                isRiskOfBiasProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-rating") {
                isEvidenceAssessmentProfile = true;
                isRecommendationRatingProfile = true;
                itemRatedHeader = "he Recommendation Being Rated";
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation-justification") {
                isEvidenceAssessmentProfile = true;
                isRecommendationRatingProfile = true;
                isRecommendationJustificationProfile = true;
                itemRatedHeader = "he Recommendation Being Rated";
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-importance") {
                isOutcomeImportanceProfile = true;
                itemRatedHeader = "he Outcome Being Rated";
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/composite-rating") {
                isCompositeRatingProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/adaptation") {
                isAdaptationProfile = true;
                itemRatedHeader = "he Resource Being Adapted";
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparison") {
                isAdaptationProfile = true;
                isComparisonProfile = true;
                itemRatedHeader = "he Index Resource Being Compared or Adapted";
            }
        }
    }

    const [artifactAssessmentResourceState, setArtifactAssessmentResourceState] = useState({});
    const [artifactReferenceEditState, setArtifactReferenceEditState] = useState(false);
    const [artifactReferenceDatatypeState, setArtifactReferenceDatatypeState] = useState('none');
    const [profileWarningsState, setProfileWarningsState] = useState({});
    const [generatedNarrativeState, setGeneratedNarrativeState] = useState("");
    const [comparedArtifactEditState, setComparedArtifactEditState] = useState(false);
    const [comparedArtifactDatatypeState, setComparedArtifactDatatypeState] = useState('none');
    const [comparedArtifactState, setComparedArtifactState] = useState({});

    useEffect(() => {
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setArtifactAssessmentResourceState(olderVersionJson);
                if (isComparisonProfile) {
                    dispatch(changeTopNavigationElements(["Compared Items", "Comparisons", "Adaptation Status"]));
                    dispatch(changeBrowserTabTitle("FEvIR Comparison - " + displayTitle));
                    dispatch(changeTool("FEvIR®: Comparison " + (editMode ? "Builder" : "Viewer")));
                    if (Array.isArray(olderVersionJson.extension) && olderVersionJson.extension.length > 0) {
                        for (const extension of olderVersionJson.extension) {
                            if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-assessment-compared" ||
                                extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-assessment-compared") {
                                if (extension.valueReference) {
                                    setComparedArtifactState({ "comparedArtifactReference": extension.valueReference });
                                }
                                if (extension.valueCanonical) {
                                    setComparedArtifactState({ "comparedArtifactUri": extension.valueCanonical });
                                }
                                if (extension.valueUri) {
                                    setComparedArtifactState({ "comparedArtifactUri": extension.valueUri });
                                }
                            }
                        }
                    }
                } else if (isAdaptationProfile) {
                    dispatch(changeTopNavigationElements(["Adapted Item", "Table View", "Adaptations", "Adaptation Status"]));
                    dispatch(changeBrowserTabTitle("FEvIR Adaptation - " + displayTitle));
                    dispatch(changeTool("FEvIR®: Adaptation " + (editMode ? "Builder" : "Viewer")));
                } else if (isOutcomeImportanceProfile) {
                    dispatch(changeTopNavigationElements(["Rated Outcome", "Ratings", "Rating Status"]));
                    dispatch(changeBrowserTabTitle("FEvIR OutcomeImportance - " + displayTitle));
                    dispatch(changeTool("FEvIR®: OutcomeImportance " + (editMode ? "Builder" : "Viewer")));
                } else if (isRecommendationJustificationProfile) {
                    dispatch(changeTopNavigationElements(["Summary", "Rated Recommendation", "Recommendation", "Evidence", "Net Effect", "Judgments", "Competing Interests", "Rating Status"]));
                    dispatch(changeBrowserTabTitle("FEvIR RecommendationJustification - " + displayTitle));
                    dispatch(changeTool("FEvIR®: RecommendationJustification " + (editMode ? "Builder" : "Viewer")));
                } else if (isRecommendationRatingProfile) {
                    dispatch(changeTopNavigationElements(["Summary", "Rated Recommendation", "Rating System", "Strength of Recommendation", "Direction of Recommendation", "Certainty of Evidence", "Other Ratings", "Rating Status"]));
                    if (!isRecommendationJustificationProfile) {
                        dispatch(changeBrowserTabTitle("FEvIR RecommendationRating - " + displayTitle));
                        dispatch(changeTool("FEvIR®: RecommendationRating " + (editMode ? "Builder" : "Viewer")));
                    }
                } else if (isRiskOfBiasProfile) {
                    dispatch(changeTopNavigationElements(["Rated Item", "Risk of Bias Assessment", "Details", "Rating Status"]));
                    dispatch(changeBrowserTabTitle("FEvIR RiskOfBias - " + displayTitle));
                    dispatch(changeTool("FEvIR®: RiskOfBias " + (editMode ? "Builder" : "Viewer")));
                } else if (isRatingProfile || isCertaintyOfEvidenceProfile) {
                    dispatch(changeTopNavigationElements(["Rated Item", "Ratings", "Rating Status"]));
                    if (isCertaintyOfEvidenceProfile) {
                        dispatch(changeBrowserTabTitle("FEvIR CertaintyOfEvidence - " + displayTitle));
                        dispatch(changeTool("FEvIR®: CertaintyOfEvidence " + (editMode ? "Builder" : "Viewer")));
                    } else {
                        dispatch(changeBrowserTabTitle("FEvIR Rating - " + displayTitle));
                        dispatch(changeTool("FEvIR®: Rating " + (editMode ? "Builder" : "Viewer")));
                    }
                } else if (isClassificationProfile) {
                    dispatch(changeTopNavigationElements(["Classified Item", "Classifications",
                        "Classification Status"]));
                    dispatch(changeBrowserTabTitle("FEvIR Classification - " + displayTitle));
                    dispatch(changeTool("FEvIR®: Classification " + (editMode ? "Builder" : "Viewer")));
                } else if (isCommentProfile) {
                    dispatch(changeTopNavigationElements(["Comment On", "Comments"]));
                    dispatch(changeBrowserTabTitle("FEvIR Comment - " + displayTitle));
                    dispatch(changeTool("FEvIR®: Comment " + (editMode ? "Builder" : "Viewer")));
                } else {
                    dispatch(changeTopNavigationElements(["Rated Item", "Ratings", "Rating Status"]));
                    dispatch(changeBrowserTabTitle("FEvIR ArtifactAssessment - " + displayTitle));
                    dispatch(changeTool("FEvIR®: ArtifactAssessment " + (editMode ? "Builder" : "Viewer")));
                }
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson) {
            setArtifactAssessmentResourceState(resourceJson);
            if (resourceJson.artifactReference) { setArtifactReferenceDatatypeState('Reference'); }
            if (resourceJson.artifactCanonical) { setArtifactReferenceDatatypeState('canonical'); }
            if (resourceJson.artifactUri) { setArtifactReferenceDatatypeState('uri'); }

            if (isComparisonProfile) {
                dispatch(changeTopNavigationElements(["Compared Items", "Comparisons", "Adaptation Status"]));
                dispatch(changeBrowserTabTitle("FEvIR Comparison - " + displayTitle));
                dispatch(changeTool("FEvIR®: Comparison " + (editMode ? "Builder" : "Viewer")));
                if (Array.isArray(resourceJson.extension) && resourceJson.extension.length > 0) {
                    for (const extension of resourceJson.extension) {
                        if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-assessment-compared" ||
                            extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-assessment-compared") {
                            if (extension.valueReference) {
                                setComparedArtifactState({ "comparedArtifactReference": extension.valueReference });
                                setComparedArtifactDatatypeState('Reference');
                            }
                            if (extension.valueCanonical) {
                                setComparedArtifactState({ "comparedArtifactUri": extension.valueCanonical });
                                setComparedArtifactDatatypeState('canonical');
                            }
                            if (extension.valueUri) {
                                setComparedArtifactState({ "comparedArtifactUri": extension.valueUri });
                                setComparedArtifactDatatypeState('uri');
                            }
                        }
                    }
                }
            } else if (isAdaptationProfile) {
                dispatch(changeTopNavigationElements(["Adapted Item", "Table View", "Adaptations", "Adaptation Status"]));
                dispatch(changeBrowserTabTitle("FEvIR Adaptation - " + displayTitle));
                dispatch(changeTool("FEvIR®: Adaptation " + (editMode ? "Builder" : "Viewer")));
            } else if (isOutcomeImportanceProfile) {
                dispatch(changeTopNavigationElements(["Rated Outcome", "Ratings", "Rating Status"]));
                dispatch(changeBrowserTabTitle("FEvIR OutcomeImportance - " + displayTitle));
                dispatch(changeTool("FEvIR®: OutcomeImportance " + (editMode ? "Builder" : "Viewer")));
            } else if (isRecommendationJustificationProfile) {
                dispatch(changeTopNavigationElements(["Summary", "Rated Recommendation", "Recommendation", "Evidence", "Net Effect", "Judgments", "Competing Interests", "Rating Status"]));
                dispatch(changeBrowserTabTitle("FEvIR RecommendationJustification - " + displayTitle));
                dispatch(changeTool("FEvIR®: RecommendationJustification " + (editMode ? "Builder" : "Viewer")));
            } else if (isRecommendationRatingProfile) {
                dispatch(changeTopNavigationElements(["Summary", "Rated Recommendation", "Rating System", "Strength of Recommendation", "Direction of Recommendation", "Certainty of Evidence", "Other Ratings", "Rating Status"]));
                if (!isRecommendationJustificationProfile) {
                    dispatch(changeBrowserTabTitle("FEvIR RecommendationRating - " + displayTitle));
                    dispatch(changeTool("FEvIR®: RecommendationRating " + (editMode ? "Builder" : "Viewer")));
                }
            } else if (isRiskOfBiasProfile) {
                dispatch(changeTopNavigationElements(["Rated Item", "Risk of Bias Assessment", "Details", "Rating Status"]));
                dispatch(changeBrowserTabTitle("FEvIR RiskOfBias - " + displayTitle));
                dispatch(changeTool("FEvIR®: RiskOfBias " + (editMode ? "Builder" : "Viewer")));
            } else if (isRatingProfile || isCertaintyOfEvidenceProfile) {
                dispatch(changeTopNavigationElements(["Rated Item", "Ratings", "Rating Status"]));
                if (isCertaintyOfEvidenceProfile) {
                    dispatch(changeBrowserTabTitle("FEvIR CertaintyOfEvidence - " + displayTitle));
                    dispatch(changeTool("FEvIR®: CertaintyOfEvidence " + (editMode ? "Builder" : "Viewer")));
                } else {
                    dispatch(changeBrowserTabTitle("FEvIR Rating - " + displayTitle));
                    dispatch(changeTool("FEvIR®: Rating " + (editMode ? "Builder" : "Viewer")));
                }
            } else if (isClassificationProfile) {
                dispatch(changeTopNavigationElements(["Classified Item", "Classifications",
                    "Classification Status"]));
                dispatch(changeBrowserTabTitle("FEvIR Classification - " + displayTitle));
                dispatch(changeTool("FEvIR®: Classification " + (editMode ? "Builder" : "Viewer")));
            } else if (isCommentProfile) {
                dispatch(changeTopNavigationElements(["Comment On", "Comments"]));
                dispatch(changeBrowserTabTitle("FEvIR Comment - " + displayTitle));
                dispatch(changeTool("FEvIR®: Comment " + (editMode ? "Builder" : "Viewer")));
            } else {
                dispatch(changeTopNavigationElements(["Rated Item", "Ratings", "Rating Status"]));
                dispatch(changeBrowserTabTitle("FEvIR ArtifactAssessment - " + displayTitle));
                dispatch(changeTool("FEvIR®: ArtifactAssessment " + (editMode ? "Builder" : "Viewer")));
            }
        }
    }, [resourceJson, editMode]);

    useEffect((() => {
        if (artifactReferenceDatatypeState === 'uri') {
            setArtifactAssessmentResourceState(prevState => { return { ...prevState, 'artifactReference': null, 'artifactCanonical': null } })
        }
        if (artifactReferenceDatatypeState === 'Reference') {
            setArtifactAssessmentResourceState(prevState => { return { ...prevState, 'artifactUri': null, 'artifactCanonical': null } })
        }
        if (artifactReferenceDatatypeState === 'canonical') {
            setArtifactAssessmentResourceState(prevState => { return { ...prevState, 'artifactReference': null, 'artifactUri': null } })
        }
    }), [artifactReferenceDatatypeState]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateNarrativeElement(artifactAssessmentResourceState, "text", "Narrative", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [artifactAssessmentResourceState.text]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = artifactAssessmentResourceState.title;
            newResourceDetail.displayTitle = artifactAssessmentResourceState.title ||
                newResourceDetail.displayTitle;
            if (artifactAssessmentResourceState.title !== undefined &&
                previousFinalValue !== artifactAssessmentResourceState.title) {
                console.log("resourceUpdate for ArtifactAssessment.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "string",
                    "title",
                    previousInitialValue,
                    artifactAssessmentResourceState.title);
            }
        }
    }, [artifactAssessmentResourceState.title]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(artifactAssessmentResourceState, "artifactReference", "Reference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [artifactAssessmentResourceState.artifactReference]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(artifactAssessmentResourceState, "artifactCanonical", "canonical", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [artifactAssessmentResourceState.artifactCanonical]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(artifactAssessmentResourceState, "artifactUri", "uri", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [artifactAssessmentResourceState.artifactUri]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(artifactAssessmentResourceState, "workflowStatus", "code", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [artifactAssessmentResourceState.workflowStatus]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(artifactAssessmentResourceState, "disposition", "code", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [artifactAssessmentResourceState.disposition]);

    return <div>
        {artifactAssessmentResourceState?.id &&
            <>
                <div id="top" ></div>
                <h1>{artifactAssessmentResourceState.title ? artifactAssessmentResourceState.title : "Edit metadata to add title"}</h1>
                <div style={{ marginTop: "12px" }}>
                    {
                        (editMode || artifactAssessmentResourceState.text) &&
                        <div>
                            <h3 id="summary">Summary</h3>
                            <div style={{ marginLeft: "24px" }}>
                                {
                                    editMode ?
                                        <>
                                            <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                                                generatedNarrative={generatedNarrativeState}
                                                startCollapsed
                                                startingValue={artifactAssessmentResourceState.text}
                                                setResourceState={setArtifactAssessmentResourceState} />
                                        </>
                                        :
                                        <>
                                            {(artifactAssessmentResourceState.text?.div && artifactAssessmentResourceState.text.status && artifactAssessmentResourceState.text.status !== "empty") ?
                                                <DisplayFromFHIRXhtml xhtml={artifactAssessmentResourceState.text.div} />
                                                : <p>[Narrative summary not generated.]</p>}
                                        </>
                                }
                            </div>
                        </div>
                    }
                    {
                        isComparisonProfile ?
                            <h3 id="compared-items">Compared Items</h3>
                            :
                            isAdaptationProfile ?
                                <h3 id="adapted-item">Adapted Item</h3>
                                :
                                isRecommendationRatingProfile ?
                                    <h3 id="rated-recommendation">Rated Recommendation</h3>
                                    :
                                    (isRatingProfile || isEvidenceAssessmentProfile) ?
                                        <h3 id="rated-item">Rated Item</h3>
                                        :
                                        isClassificationProfile ?
                                            <h3 id="classified-item">Classified Item</h3>
                                            :
                                            isCommentProfile ?
                                                <h3 id="comment-on">Comment On</h3>
                                                :
                                                isOutcomeImportanceProfile ?
                                                    <h3 id="rated-outcome">Rated Outcome</h3>
                                                    :
                                                    <h3 id="rated-item">Rated Item</h3>
                    }
                    <div style={{ marginLeft: "24px" }}>
                        {
                            editMode ?
                                <>
                                    <div><b>T{itemRatedHeader}: </b>
                                        <DisplayFromFHIRReference reference={artifactAssessmentResourceState.artifactReference} />
                                        <DisplayFromFHIRReference uri={artifactAssessmentResourceState.artifactUri ||
                                            artifactAssessmentResourceState.artifactCanonical} />
                                        <span className={"unselectable"}
                                            style={{ marginLeft: "24px", cursor: "pointer" }}
                                            onClick={() => setArtifactReferenceEditState(!artifactReferenceEditState)}>
                                            <i>Change t{itemRatedHeader}</i>&nbsp;&nbsp;
                                            {artifactReferenceEditState ? <>▼</> : <>►</>}
                                        </span>
                                    </div>
                                    {artifactReferenceEditState &&
                                        <div style={{ whiteSpace: "pre-wrap", paddingLeft: "24px" }}>
                                            <DatatypeSelector elementXName='artifact[x]'
                                                allowedDatatypes={['Reference', 'canonical', 'uri']}
                                                datatypeState={artifactReferenceDatatypeState}
                                                setDatatypeState={setArtifactReferenceDatatypeState} />
                                            {(artifactReferenceDatatypeState === 'uri') &&
                                                <UriEntry elementName='artifactUri'
                                                    fieldLabel={'T' + itemRatedHeader + ' (by URL)'}
                                                    startingValue={artifactAssessmentResourceState.artifactUri || null}
                                                    setResourceState={setArtifactAssessmentResourceState} />}
                                            {(artifactReferenceDatatypeState === 'Reference') &&
                                                <ReferenceEntry elementName='artifactReference'
                                                    fieldLabel={'T' + itemRatedHeader}
                                                    enableCreation={true}
                                                    startingResourceType={isOutcomeImportanceProfile && "EvidenceVariable"}
                                                    startingValue={artifactAssessmentResourceState.artifactReference || null}
                                                    setResourceState={setArtifactAssessmentResourceState} />}
                                            {(artifactReferenceDatatypeState === 'canonical') &&
                                                <UriEntry elementName='artifactCanonical'
                                                    fieldLabel={'T' + itemRatedHeader + ' (by Canonical URL)'}
                                                    startingValue={artifactAssessmentResourceState.artifactCanonical || null}
                                                    setResourceState={setArtifactAssessmentResourceState} />}
                                            <br />
                                        </div>
                                    }
                                    {isComparisonProfile &&
                                        <>
                                            <div>
                                                <b>The Resource(s) Being Compared</b>
                                                {artifactAssessmentResourceState.extension.map((extension, extensionIndex) => {
                                                    return <div key={extensionIndex}>
                                                        {(extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-assessment-compared" ||
                                                            extension.url === "https://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-assessment-compared") &&
                                                            <>
                                                                {extension.valueReference && <DisplayFromFHIRReference reference={extension.valueReference} />}
                                                                {extension.valueCanonical && <DisplayFromFHIRUri uri={extension.valueCanonical} />}
                                                                {extension.valueUri && <DisplayFromFHIRUri uri={extension.valueUri} />}
                                                            </>}
                                                    </div>
                                                })}
                                                <span className={"unselectable"} style={{ marginLeft: "24px", cursor: "pointer" }}
                                                    onClick={() => { setComparedArtifactEditState(!comparedArtifactEditState) }}>
                                                    <i>Change the Resource(s) Being Compared (i.e. Edit the Extensions)</i>&nbsp;&nbsp;
                                                    {comparedArtifactEditState ? <>▼</> : <>►</>}
                                                </span>
                                            </div>
                                            {comparedArtifactEditState &&
                                                <ArrayEntry datatype='Extension' elementName='extension'
                                                    fieldLabel='The Resource Being Compared'
                                                    extensionUrl='http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-assessment-compared'
                                                    startingValue={artifactAssessmentResourceState.extension}
                                                    setResourceState={setArtifactAssessmentResourceState} />
                                            }
                                            {!artifactAssessmentResourceState.content &&
                                                <Button className="formButton positive" content="Create Comparison" compact
                                                    onClick={() => {
                                                        //TODO - add createComparison
                                                        //createComparison(artifactAssessmentResourceState, setArtifactAssessmentResourceState)
                                                        alert("Function not yet created.")
                                                    }} />
                                            }
                                        </>
                                    }
                                </>
                                :
                                <>
                                    {artifactAssessmentResourceState.artifactReference && <DisplayFromFHIRReference reference={artifactAssessmentResourceState.artifactReference} />}
                                    {artifactAssessmentResourceState.artifactCanonical && <DisplayFromFHIRUri uri={artifactAssessmentResourceState.artifactCanonical} />}
                                    {artifactAssessmentResourceState.artifactUri && <DisplayFromFHIRUri uri={artifactAssessmentResourceState.artifactUri} />}
                                    {isComparisonProfile &&
                                        <>
                                            <h4>Other Item</h4>
                                            {comparedArtifactState.comparedArtifactReference &&
                                                <DisplayFromFHIRReference reference={comparedArtifactState.comparedArtifactReference} />
                                            }
                                            {comparedArtifactState.comparedArtifactUri &&
                                                <DisplayFromFHIRUri uri={comparedArtifactState.comparedArtifactUri} />
                                            }
                                            {comparedArtifactState.comparedArtifactCanonical &&
                                                <DisplayFromFHIRUri uri={comparedArtifactState.comparedArtifactCanonical} />
                                            }
                                        </>
                                    }
                                </>
                        }
                    </div>
                    {(isAdaptationProfile && !isComparisonProfile) &&
                        <div>
                            <h3 id="table-view">Table View</h3>
                            <AdaptationTableDisplay contentArray={artifactAssessmentResourceState.content} />
                        </div>
                    }
                    {
                        isComparisonProfile ?
                            <h3 id="comparisons">Comparisons</h3>
                            :
                            isAdaptationProfile ?
                                <h3 id="adaptations">Adaptations</h3>
                                :
                                isCommentProfile ?
                                    <h3 id="comments">Comments</h3>
                                    :
                                    isRecommendationJustificationProfile ?
                                        <h3 id="recommendation-justification">Recommendation Justification</h3>
                                        :
                                        isRecommendationRatingProfile ?
                                            <h3 id="recommendation-rating">Recommendation Rating</h3>
                                            :
                                            isRiskOfBiasProfile ?
                                                <h3 id="risk-of-bias-assessment">Risk of Bias Assessment</h3>
                                                :
                                                isCommentProfile ?
                                                    <h3 id="comments">Comments</h3>
                                                    :
                                                    isClassificationProfile ?
                                                        <h3 id="classifications">Classifications</h3>
                                                        :
                                                        <h3 id="ratings">Ratings</h3>
                    }
                    {(artifactAssessmentResourceState.content?.length > 0) &&
                        artifactAssessmentResourceState.content.map((content, contentIndex) => {
                            return <div key={contentIndex}>
                                <ArtifactAssessmentContentDisplay foi={foi}
                                    contentIndex={contentIndex}
                                    isClassificationProfile={isClassificationProfile}
                                    isCommentProfile={isCommentProfile}
                                    isOutcomeImportanceProfile={isOutcomeImportanceProfile}
                                    isCertaintyOfEvidenceProfile={isCertaintyOfEvidenceProfile} />
                                <br />
                            </div>
                        })}
                    {editMode &&
                        <Button className="formButton" style={{ color: "#000000" }}
                            content="+ Add Content"
                            onClick={() => {
                                setArtifactAssessmentResourceState(prevState => {
                                    let newContent = prevState.content?.length > 0 ?
                                        prevState.content.concat(emptyContent)
                                        :
                                        [emptyContent];
                                    return { ...prevState, "content": newContent };
                                });
                            }}
                        />
                    }
                    {(!isCommentProfile) &&
                        <div>
                            {
                                (isComparisonProfile || isAdaptationProfile) ?
                                    <h3 id="adaptation-status">Adaptation Status</h3>
                                    :
                                    isClassificationProfile ?
                                        <h3 id="classification-status">Classification Status</h3>
                                        :
                                        <h3 id="rating-status">Rating Status</h3>
                            }
                            {editMode ?
                                <CodeEntry elementName='workflowStatus' fieldLabel='Workflow status'
                                    startingValue={artifactAssessmentResourceState.workflowStatus}
                                    setResourceState={setArtifactAssessmentResourceState}
                                    allowedValues={["submitted", "triaged", "waiting-for-input", "resolved-no-change",
                                        "resolved-change-required", "deferred", "duplicate", "applied", "published",
                                        "entered-in-error"]} />
                                :
                                <p><b>Workflow status: </b>{artifactAssessmentResourceState.workflowStatus}</p>
                            }
                            {editMode ?
                                <CodeEntry elementName='disposition' fieldLabel='Disposition'
                                    startingValue={artifactAssessmentResourceState.disposition}
                                    setResourceState={setArtifactAssessmentResourceState}
                                    allowedValues={["unresolved", "not-persuasive", "persuasive",
                                        "persuasive-with-modification",
                                        "not-persuasive-with-modification"]} />
                                :
                                <p><b>Disposition: </b>{artifactAssessmentResourceState.disposition}</p>
                            }
                        </div>
                    }
                </div>
            </>}
    </div>
}

export default ArtifactAssessmentDisplay;